import React, { useEffect, useState } from 'react';
import ShareModal from '../../components/ShareModal/ShareModal';
import { ShareDetailPageStyle } from './ShareDetailPageStyle.style';
import { BASE_URL } from '../../constants/api-urls';
import axios from 'axios';
import { getRefreshedToken } from '../../utils';
import SpotifyApiService from '../../services/SpotifyApiService';

function ShareDetailPage() {
  const [shareSongModal, setShareSongModal] = useState(true);
  const [ViewDetailData, setViewDetailData] = useState({});
  const [currentPlaylistData, setCurrentPlaylistData] = useState<any>({});
  const [PlaylistRefreshRecord, setPlaylistRefreshRecord] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    setLoader(true);
    const fetchData = async () => {
      try {
        // @ts-ignore
        const shareToken = new URL(window.location).searchParams.get('token');
        axios(`${BASE_URL}/decodeShareLinkToken/`, {
          data: {
            token: shareToken,
          },
          method: 'post',
        }).then(link => {
          const url = link.data.data;
          const uri = url.uri;
          const id = url.id;
          const playlistId = url.playlistId;
          const refreshToken = url.ref;
          const position = url.position;
          const originalDate = url.originalDate;

          // Current backend returns an access token; older backends returned the refresh token.
          const tokenRequest = url.accessToken
            ? Promise.resolve({ data: { access_token: url.accessToken } })
            : getRefreshedToken(refreshToken);
          tokenRequest.then(async response => {
            let token = response?.data?.access_token;
            if (token) {
              if (uri && playlistId) {
                const config = {
                  token: shareToken,
                  song_uri: uri,
                  selected_playlist_id: playlistId,
                };

                // Post request to get song details from your backend
                const response = await axios.post(`${BASE_URL}/getSongDetails`, config);
                let responseSong = null;
                // Get request to Spotify API to get additional song details
                await SpotifyApiService.getInstance()
                  .makeRequestWithToken(
                    {
                      method: 'GET',
                      url: `https://api.spotify.com/v1/tracks/${id}`,
                      headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                      },
                    },
                    token
                  )
                  .then(resSong => {
                    responseSong = resSong;
                  })
                  .catch(() => {});

                if (playlistId) {
                  SpotifyApiService.getInstance()
                    .makeRequestWithToken(
                      {
                        method: 'GET',
                        url: `https://api.spotify.com/v1/playlists/${playlistId}`,
                      },
                      token
                    )
                    .then(responses => {
                      let currentPlaylistContent = responses.data;
                      setCurrentPlaylistData(currentPlaylistContent);

                      // Check if both responses are valid
                      if (response?.data) {
                        setPlaylistRefreshRecord(response.data?.data?.PlaylistRefreshRecords);
                      }
                    })
                    .catch(async error => {
                      setLoader(false);
                    });
                }
                setLoader(false);

                setViewDetailData({
                  ...ViewDetailData,
                  notes: response.data?.data?.songData?.notes || '',
                  track: {
                    name:
                      responseSong?.data?.name || response.data?.data?.songData?.song_name || '',
                    artists: [
                      {
                        name:
                          responseSong?.data?.artists[0]?.name ||
                          response.data?.data?.songData?.artist_name ||
                          '',
                      },
                    ],
                    album: {
                      images: [
                        {
                          url: responseSong?.data?.album?.images[0]?.url || '',
                        },
                      ],
                    },
                    uri:
                      responseSong?.data?.songData?.uri ||
                      response.data?.data?.songData?.song_name ||
                      uri ||
                      '',
                  },
                  popularity: responseSong?.data?.popularity ?? '--',
                  position: position,
                  added_at:
                    originalDate ||
                    response.data?.data?.songData?.started_time ||
                    response.data?.data?.songData?.start_time,
                  endTime:
                    response.data?.data?.songData?.end_time === 'null'
                      ? '-'
                      : response.data?.data?.songData?.end_time || '',
                  song_uri: responseSong?.data?.songData?.uri || '',
                  selected_playlist_id: response.data?.data?.songData?.selected_playlist_id || '',
                });
              }
            }
          });
        });
      } catch (error) {
        console.error('Error fetching song details:', error);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ShareDetailPageStyle>
      <ShareModal
        isModalVisible={shareSongModal}
        setIsModalVisible={() => {
          setShareSongModal(false);
          if (window.location.pathname.includes('track-detail')) {
            window.location.href = '/';
            return;
          }
        }}
        editType={'viewDetail'}
        ViewDetailData={ViewDetailData}
        setViewDetailData={setViewDetailData}
        currentPlaylistData={currentPlaylistData}
        PlaylistRefreshRecord={PlaylistRefreshRecord}
        showCopyUrl={false}
        scheduleSong={false}
        detailLoader={loader}
      />
    </ShareDetailPageStyle>
  );
}

export default ShareDetailPage;
